import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie } from "src/utils/cookieUtil";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";
import { UserVo } from "src/vo/userVo";

const serverIp = process.env.REACT_APP_SERVER_IP;

// 1-1. initial state 객체 생성
const initialState: UserVo = {};

export const alarmAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  reducerPath: "alarmAPI",
  endpoints: (builder) => ({
    // 알림 리스트 조회
    alarmList: builder.query({
      query: () => ({
        url: `push/list`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // 알림 설정 리스트 조회
    alarmSettingList: builder.query({
      query: () => ({
        url: `push/setting`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // 알림 모두 읽음
    readAllAlarm: builder.mutation({
      query: () => ({
        url: `push/read-list/all`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // 개별 알림 읽음
    readAlarm: builder.mutation({
      query: ({ push_idx }) => ({
        url: `push/read-list/${push_idx}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // 알림 설정
    setAlarm: builder.mutation({
      query: ({ push_type, YN }) => ({
        url: `push/setting/${push_type}/${YN}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
  }),
});

export const { useAlarmListQuery, useAlarmSettingListQuery, useReadAllAlarmMutation, useReadAlarmMutation, useSetAlarmMutation } = alarmAPI;
